<div class="firma-canvas-container">
  <div class="canvas-wrapper">
    <canvas
      #signatureCanvas
      class="signature-canvas"
    ></canvas>
    <div class="canvas-placeholder" *ngIf="isEmpty">
      Dibuje su firma aqui
    </div>
  </div>

  <div class="canvas-actions">
    <button
      type="button"
      mat-stroked-button
      class="clear-button"
      (click)="limpiar()"
      [disabled]="isEmpty"
    >
      <mat-icon>clear</mat-icon>
      Limpiar
    </button>
  </div>
</div>
